import { FC, useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import YouTube from "react-youtube";

interface VideoItem {
  id: string;
  title: string;
  youtubeId: string;
  description?: string;
}

interface VideoGalleryProps {
  videos: VideoItem[];
  sectionTitle: string;
}

export const VideoGallery: FC<VideoGalleryProps> = ({ videos, sectionTitle }) => {
  const [videoWatched, setVideoWatched] = useState<Array<string>>([]);

  const getVideoIdFromUrl = (url: string): string => {
    const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
    return match ? match[1] : "";
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3 }}>
        Videos {sectionTitle}
      </Typography>
      
      <Grid container spacing={3}>
        {videos.map((video, index) => {
          const videoId = getVideoIdFromUrl(video.youtubeId);
          
          return (
            <Grid item xs={12} sm={6} key={video.id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.2s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 4,
                  },
                }}
              >
                <Box sx={{ position: "relative", height: "422px" }}>
                  <YouTube
                    videoId={videoId}
                    id={videoId}
                    style={{ width: "100%", height: "100%" }}
                    opts={{ 
                      width: "100%", 
                      height: "100%",
                      playerVars: {
                        autoplay: 0,
                        controls: 1,
                        modestbranding: 1,
                        rel: 0,
                      }
                    }}
                    title={video.title}
                    onPlay={(e: any) => {
                      e.target.int = setInterval(() => {
                        const watched = e.target.getCurrentTime();
                        const duration = e.target.getDuration();

                        console.log(watched, duration);

                        if (watched / duration >= 0.9) {
                          setVideoWatched((prev) => [
                            ...prev,
                            videoId,
                          ]);
                        }
                      }, 1000);
                    }}
                    onPause={(e: any) => {
                      e.target.int && clearInterval(e.target.int);
                    }}
                    onEnd={(e: any) => {
                      e.target.int && clearInterval(e.target.int);
                    }}
                  />
                </Box>
                
                <CardContent sx={{ flexGrow: 1, p: 2 }}>
                  <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 600,
                      lineHeight: 1.3,
                      mb: 1,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {video.title}
                  </Typography>
                  
                  {video.description && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        fontSize: "0.875rem",
                      }}
                    >
                      {video.description}
                    </Typography>
                  )}
                  
                  <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Chip
                      label={`Video ${index + 1}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                    {videoWatched.includes(videoId) && (
                      <Chip
                        label="Gesehen"
                        size="small"
                        color="success"
                        variant="filled"
                      />
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
